import { Component, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs';

import { TriggerAction } from '@shared/actions';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';

@Component({
  selector: 'app-update-indicator',
  templateUrl: './update-indicator.component.html',
  styleUrls: ['./update-indicator.component.scss'],
})
export class UpdateIndicatorComponent {
  @Output() updateEvent = new EventEmitter<void>();

  public updateAction: TriggerAction;

  constructor(private _stateManagerProjectService: StateManagerProjectService) {
    this.updateAction = new TriggerAction(
      '',
      'Update',
      this._onUpdateBtnClick.bind(this)
    );

    this.updateAction.isEnable = () =>
      this._stateManagerProjectService.isDisabledAllToolsForChangeMask$.pipe(
        map((x) => !x)
      );
  }

  private _onUpdateBtnClick(): void {
    this.updateEvent.emit();
  }
}
